import React, { Component } from 'react';
import { Table, Switch, Radio } from 'antd';
import PropTypes from 'prop-types';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import ButtonPerssion from '@/routes/ButtonPerssion';


export default class TableContent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    _columns = () => ([
        {
            title: '规则名称',
            dataIndex: 'dispatchName',
            key: 'dispatchName',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '推送范围(米)',
            dataIndex: 'dispatchRange',
            key: 'dispatchRange',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '推送人数',
            dataIndex: 'pushNumber',
            key: 'pushNumber',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '运营公司',
            dataIndex: 'companyName',
            key: 'companyName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '规则状态',
            dataIndex: 'status',
            key: 'status',
            width: '10%',
            align: 'center',
            render: (text, item) => this._switchCell(text, item)
        },
        {
            title: '首页规则',
            dataIndex: 'isIndex',
            key: 'isIndex',
            width: '10%',
            align: 'center',
            render: (text, item) => this._radioCell(text, item)
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '10%',
            render: (id, record) => this._tableAction(id, record)
        }
    ]);

    _tableAction = (id, record) => {
        const { tableAction } = this.props;
        return (< div className={styles.action} >
            <ButtonPerssion code='system/operatingrule/edit'>
                {id >= 1000 && <div className={styles.item} onClick={() => tableAction(id, 'editor')}>编辑</div>}
            </ButtonPerssion>
            <ButtonPerssion code='system/operatingrule/delete'>
                <div className={styles.item} onClick={() => tableAction(id, 'delete')}>删除</div>
            </ButtonPerssion>
        </div >);
    };

    // 开关
    _switchCell = (sw, item) => {
        let checked = true;
        if (sw == '0') {
            checked = false;
        }
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                <Switch
                    checkedChildren="ON"
                    unCheckedChildren="OFF"
                    checked={checked}
                    onChange={(value) => {
                        this.props.tableAction(item, 'switch', value);
                    }}
                />
            </div>
        );
    };

    // 单选
    _radioCell = (sw, item) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                <Radio.Group
                    onChange={(value) => {
                        this.props.tableAction(item, 'radio', value);
                    }}
                    value={sw}
                >
                    <Radio value={1} />
                </Radio.Group>
                <span>首页规则</span>
            </div>
        );
    };


    // 解析表格数据，使符合columns格式要求
    _takeDataSource = (data) => {
        if (data) {
            return data.map(item => {
                return item;
            });
        }
    }

    //渲染组件
    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object, // 表格数据源
    paginationChange: PropTypes.func, // 分页
    tableAction: PropTypes.func, // 对表格的操作
};